import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const ownershipOptions = [
  { value: "Concession", label: "Concession" },
  { value: "Investor-owned utility", label: "Investor-owned utility" },
  { value: "Part-privatised", label: "Part-privatised" },
  { value: "Public ownership", label: "Public ownership" },
];

const OwnershipSelect = ({ onOwnershipChange, selectedOwnershipOptions }) => (
  <Select
    classNamePrefix="Select"
    classNames={{ container: () => "Select__container" }}
    onChange={e => onOwnershipChange(e)}
    options={ownershipOptions}
    placeholder="Ownership type..."
    value={selectedOwnershipOptions}
    isMulti
    isSearchable={false}
  />
);

OwnershipSelect.propTypes = {
  onOwnershipChange: PropTypes.func.isRequired,
  selectedOwnershipOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }))
};

export default OwnershipSelect;
